import { createAction, props } from '@ngrx/store';
import { StreamingConfig, ConfigEditorDetailVariant } from '../../domain/config';

const feature = '[CXB Config streaming editor Screen]';

export const loadCxbStreamingConfigEntries = createAction(`${feature} Load config entries`);
export const loadCxbStreamingConfigEntriesSuccess = createAction(
  `${feature} Load config entries success`,
  props<{ configs: StreamingConfig[] }>()
);
export const loadCxbStreamingConfigEntriesFail = createAction(`${feature} Load config entries fail`, props<{ errorMessage: string }>());

export const loadCxbStreamingConfigEntry = createAction(`${feature} Load config entry`, props<{ key: string }>());
export const loadCxbStreamingConfigEntrySuccess = createAction(
  `${feature} Load config entry success`,
  props<{ config: StreamingConfig; variant: ConfigEditorDetailVariant }>()
);
export const loadCxbStreamingConfigEntryFail = createAction(`${feature} Load config entry fail`, props<{ errorMessage: string }>());

export const leaveConfigEditorDetailScreen = createAction(`${feature} Leave config editor detail screen`);

export const createCxbStreamingConfigEntry = createAction(`${feature} Create config entry`, props<{ config: StreamingConfig }>());
export const createCxbStreamingConfigEntrySuccess = createAction(`${feature} Create config entry success`, props<{ key: string }>());
export const createCxbStreamingConfigEntryFail = createAction(`${feature} Create config entry fail`, props<{ errorMessage: string }>());

export const updateCxbStreamingConfigEntry = createAction(`${feature} Update config entry`, props<{ config: StreamingConfig }>());
export const updateCxbStreamingConfigEntrySuccess = createAction(`${feature} Update config entry success`, props<{ key: string }>());
export const updateCxbStreamingConfigEntryFail = createAction(`${feature} Update config entry fail`, props<{ errorMessage: string }>());

export const deleteCxbStreamingConfigEntry = createAction(`${feature} Delete config entry`, props<{ key: string }>());
export const deleteCxbStreamingConfigEntrySuccess = createAction(`${feature} Delete config entry success`, props<{ key: string }>());
export const deleteCxbStreamingConfigEntryFail = createAction(`${feature} Delete config entry fail`, props<{ errorMessage: string }>());
